import constants from "./constants.js";

const volumeRangeMapping = {
  0: -6000,
  0.1: -2000,
  0.2: -1400,
  0.3: -900,
  0.4: -800,
  0.5: -602,
  0.6: -450,
  0.7: -320,
  0.8: -200,
  0.9: -100,
  1: 0,
};

function init() {
  return new Promise((resolve, reject) => {
    const io = require('socket.io-client');
    this.socket = io('http://localhost:' + constants.utilRaspberryPort);
    this.socket.on('connect', () => {
      console.log('util raspberry server connected');

      resolve();
    });
    this.socket.on('connect_error', () => {
      console.error('util raspberry server connection error');

      resolve();
    });
  });
}

function on(event, cb) {
  this.socket.on(event, cb);
}

function emit(event, msg) {
  this.socket.emit(event, msg);
}

function onVideoPlayFail(callback) {
  this.socket.on('videoPlayFail', callback);
}

function onVideoPlayEnded(callback) {
  this.socket.on('videoPlayEnded', callback);
}

function playVideo({ playerId, urls, winPositions, volume = 1, audioOutput }) {
  this.socket.emit('createPlayer', {
    playerId,
    urls,
    winPositions,
    volume: volumeRangeMapping[volume],
    audioOutput,
  });
}

function pauseVideo({ playerId, shouldHidePlayer = true }) {
  this.socket.emit('pausePlayer', {
    playerId,
    shouldHidePlayer,
  });
}

function resumeVideo({ playerId }) {
  this.socket.emit('resumePlayer', {
    playerId,
  });
}

function stopVideo({ playerId, shouldHidePlayer = true }) {
  this.socket.emit('stopPlayer', {
    playerId,
    shouldHidePlayer,
  });
}

function closeVideo({ playerId }) {
  this.socket.emit('closePlayer', {
    playerId,
  });
}

function setVolume({ playerId, volume }) {
  this.socket.emit('setVolume', {
    playerId,
    volume,
  });
}

function playAudio({ urls }) {
  this.socket.emit('playAudio', {
    urls,
  });
}

function onAudioPlayFail(callback) {
  this.socket.on('audioPlayFail', callback);
}

function onAudioPlayEnded(callback) {
  this.socket.on('audioPlayEnded', callback);
}

function startHeartbeat() {
  this.socket.emit('startHeartbeat', {});
}

function heartbeat() {
  this.socket.emit('heartbeat', {});
}

function endHeartbeat() {
  this.socket.emit('endHeartbeat', {});
}

export {
  init,
  on,
  emit,
  playVideo,
  pauseVideo,
  resumeVideo,
  stopVideo,
  closeVideo,
  onVideoPlayFail,
  onVideoPlayEnded,
  setVolume,
  playAudio,
  onAudioPlayFail,
  onAudioPlayEnded,
  startHeartbeat,
  heartbeat,
  endHeartbeat,
};


// WEBPACK FOOTER //
// client/common/raspberry.js